import axios from './axios';

import auth from '../resources/Auth';

const API_URL = process.env.REACT_APP_API_URL;

export default {
  all: async () => {
    const url = `${API_URL}/rentalDevice`;

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  findOne: async (id) => {
    const url = `${API_URL}/rentalDevice/${id}`;

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },
};
